import { render, staticRenderFns } from "./tm-attr.vue?vue&type=template&id=d7d4b728&scoped=true&"
import script from "./tm-attr.vue?vue&type=script&lang=ts&"
export * from "./tm-attr.vue?vue&type=script&lang=ts&"
import style0 from "./tm-attr.vue?vue&type=style&index=0&id=d7d4b728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d4b728",
  null
  
)

export default component.exports